import { useRef, useEffect, useContext, useState } from "react";

import BlockchainContext from "../store/BlockchainContext";
import { numberWithCommas } from "../utils/util";

const DepositModalBox = ({ handleClose }) => {
  const [depositAmount, setDepositAmount] = useState();
  const modalRef = useRef(null);
  const ModalContainerRef = useRef(null);
  const { walletBalance, handleInvest, lastDepositValue } =
    useContext(BlockchainContext);

  const handleClickOutside = (event) => {
    if (ModalContainerRef.current && !modalRef.current.contains(event.target)) {
      handleClose();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDeposit = (event) => {
    event.preventDefault();
    if (depositAmount > 0) {
      handleInvest(depositAmount);
      setDepositAmount("");
      handleClose();
    }
  };

  var lastDeposit = parseFloat(lastDepositValue);
  var minDeposit = lastDeposit ? lastDeposit + (lastDeposit * 10) / 100 : 0.05;

  const handlePercent = (event, percent) => {
    event.preventDefault();
    setDepositAmount(
      numberWithCommas(
        (Number(walletBalance) > 0.1 ? walletBalance - 0.1 : walletBalance) *
          percent,
        5
      )
    );
  };
  return (
    <div className="modalContainer" ref={ModalContainerRef}>
      <div className="modal-deposit" ref={modalRef}>
        <h2>Deposit</h2>
        <button
          type="button"
          className="fancybox-button fancybox-close-small"
          onClick={() => handleClose()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1"
            viewBox="0 0 24 24"
          >
            <path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path>
          </svg>
        </button>
        <div className="modal-wrap">
          <form onSubmit={handleDeposit}>
            <h5>
              MATIC in Your Wallet:{" "}
              <span>{numberWithCommas(walletBalance, 5)} MATIC</span>
            </h5>

            <h5>
              Minimum Deposit:{" "}
              <span>{numberWithCommas(minDeposit, 5)} MATIC</span>
            </h5>
            <span className="input-wrap">
              <input
                type="text"
                placeholder="0.00"
                onChange={(event) => setDepositAmount(event.target.value)}
                value={depositAmount}
              />
            </span>
            <div className="form-percents">
              <button
                className="small"
                onClick={(event) => handlePercent(event, 0.1)}
              >
                10%
              </button>
              <button
                className="small"
                onClick={(event) => handlePercent(event, 0.25)}
              >
                25%
              </button>
              <button
                className="small"
                onClick={(event) => handlePercent(event, 0.5)}
              >
                50%
              </button>
              <button
                className="small"
                onClick={(event) => handlePercent(event, 0.75)}
              >
                75%
              </button>
              <button
                className="small"
                onClick={(event) => handlePercent(event, 1)}
              >
                100%
              </button>
            </div>
            <button type="submit" className="button">
              <span>Deposit</span>
            </button>
            <div className="small form-agreement">
              The principal deposit cannot be withdrawn, the only return users
              can get are daily dividends and referral rewards. Payments is
              possible only if contract balance have enough MATIC. Please
              analyze the transaction history and balance of the smart contract
              before investing.
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DepositModalBox;
